package horcrux.frontend.common.views.components.input

import horcrux.frontend.common.configs.StaticContentConfigs
import js.objects.jso
import mui.icons.material.Help
import mui.material.PaletteMode
import mui.material.Paper
import mui.material.Popover
import mui.material.SvgIconSize
import mui.material.Typography
import mui.material.styles.createTheme
import mui.system.PropsWithSx
import mui.system.ThemeProvider
import mui.system.sx
import react.FC
import react.Props
import react.useState
import web.cssom.WhiteSpace
import web.cssom.pt
import web.svg.SVGSVGElement

external interface InfoPopoverProps : PropsWithSx {
    var id: String
    var text: String
}

val darkTheme = createTheme(options = jso {
    this.palette = jso {
        this.mode = PaletteMode.dark
    }
});

val InfoPopover = FC<InfoPopoverProps> { props ->
    var anchorElMaybe by useState<SVGSVGElement?>(null)
    val isOpen = anchorElMaybe != null

    fun open(anchorEl: SVGSVGElement) {
        anchorElMaybe = anchorEl
    }

    fun close() {
        anchorElMaybe = null
    }

    Help {
        this.fontSize = SvgIconSize.small
        this.id = "${props.id}-icon"
        this.onClick = { open(it.currentTarget) }
        this.sx { +props.sx }
    }
    Popover {
        this.id = "${props.id}-info"
        this.open = isOpen
        this.onClose = { _, _ -> close() }
        this.anchorEl = anchorElMaybe
        this.anchorOrigin = jso {
            this.vertical = "bottom"
            this.horizontal = "left"
        }
        this.sx {
            this.maxWidth = 500.pt
        }
        ThemeProvider {
            this.theme = darkTheme
            Paper {
                this.sx {
                    this.minWidth = 200.pt
                    this.backgroundColor = StaticContentConfigs.BLUE
                }
                Typography {
                    this.sx {
                        this.whiteSpace = WhiteSpace.preLine
                        this.padding = 2.pt
                    }
                    +props.text
                }
            }
        }
    }
}
